exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Styles used in DepartmentList.jsx */\n\n\n.list-box>div:hover {\n    box-shadow: none;\n    transform: scale(1, 1);\n    z-index: 1;\n    transition: all 0.5s;\n}\n\n.view-switch-button {\n    border-radius: 1rem !important;\n    font-size: 0.8rem !important;\n    margin: 0% 2%;\n}\n\n.cgrid {\n    padding: 0px !important;\n}\n\nh6 {\n    margin-left: 10px;\n}", ""]);

// exports
